/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authorize } from "../services/api";
import LoadingOverlay from "./Loading";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const paramsToken =
    new URLSearchParams(window.location.search).get("token") || null;
  const email =
    new URLSearchParams(window.location.search).get("username") || null;

  const navigate = useNavigate();
  async function getToken() {
    try {
      setLoading(true);
      const authData = (await authorize(paramsToken || "", email || "")) as any;

      if (authData && authData.data) {
        const authToken = authData.data.token;
        if (authToken && authToken.length > 1) {
          navigate("/auth?code=" + paramsToken + "&username=" + email);
          setLoading(false);
        } else {
          const selectedToken = authData.data.token[0];
          const user = {
            name: selectedToken?.username,
          };
          localStorage.setItem("token", paramsToken || "");
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("baseUrl", selectedToken.base_url);
          localStorage.setItem("business_id", selectedToken.business_id);

          localStorage.setItem("session", selectedToken.session_id);
          localStorage.setItem("accessToken", selectedToken.access_token);
          setLoading(false);
          navigate("/");
          toast.success("Login successful");
        }
      } else {
        toast.error("Authorization failed");
        setLoading(false);
        navigate("/login");
      }
    } catch (error: any) {
      toast.error(error.message || "Authorization failed");
      navigate("/login");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (paramsToken) {
      getToken();
    }
  }, [paramsToken]);

  if (!paramsToken && !token) {
    return (
      <>
        <Navigate to="/login" />
      </>
    );
  }
  if (paramsToken) {
    return <LoadingOverlay isLoading={loading} />;
  }

  return children;
};

export default ProtectedRoute;
